import { Controller } from "@hotwired/stimulus"

// Dismisses a flash message, either on click or after a delay.
// Notices auto-dismiss; alerts pass 0 so they stay until the user closes them.
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 0 } }

  connect() {
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("opacity-0")
    setTimeout(() => this.element.remove(), 200)
  }
}
